module.exports = __webpack_public_path__ + "img/eye_bags_female.a64b4c26.png";